<nav id="navbar" class="navbar navbar-expand-md p-0">
  <a routerLink="/dashboard" class="navbar-brand d-sm-inline-block text-center" title="{{COMPANY_NAME}} home">
    <img src="/assets/img/barkani_logo_white.svg" alt="{{COMPANY_NAME}}" />
  </a>
  <div class="bk-mobile-actions d-flex d-md-none align-items-center ms-auto">
    <button type="button" class="bk-mobile-bell" (click)="mobileModal = 'notifications'" title="Notifications"
      aria-label="Notifications">
      <i class="mdi mdi-bell-outline"></i>
      <span class="bk-bar-badge" *ngIf="unreadNotificationsCount > 0">{{ unreadNotificationsCount }}</span>
    </button>
    <button type="button" class="bk-mobile-tasks" (click)="mobileModal = 'tasks'" title="Tasks" aria-label="Tasks">
      <i class="mdi mdi-format-list-checks"></i>
      <span class="bk-bar-badge" *ngIf="userChecklist.length > 0">{{ userChecklist.length }}</span>
    </button>
    <span class="bk-mobile-divider" aria-hidden="true"></span>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarWrapper"
      aria-controls="navbarWrapper" aria-expanded="false" aria-label="Toggle navigation"
      (click)="onMobileNavToggle()">
      <i class="mdi mdi-menu" aria-hidden="true"></i>
    </button>
  </div>

  <div id="navbarWrapper" class="collapse navbar-collapse">
    <ul id="top-menu" class="navbar-nav align-items-center">
      <li class="nav-item topbar__ctx">
        <bk-context-switcher
          [companies]="companies"
          [label]="getCurrentCompanyId() ? (getCompanyName() + ' — ' + getBureauName()) : null"
          [image]="getBureauImage()"
          [canSwitch]="canSwitchContext()"
          [activeCompanyId]="getCurrentCompanyId()"
          [activeBureauId]="getCurrentBureauId()"
          [user]="user"
          (bureauSelect)="selectBureau($event.companyId, $event.companyName, $event.bureauId, $event.bureauName)"
          (grantsSelect)="selectGrants($event.companyId, $event.companyName)"
          (defaultBureauChange)="setDefaultBureau($event.companyId, $event.bureauId)">
        </bk-context-switcher>
      </li>
      <li class="nav-item topbar__search" *ngIf="companies && companies.length && getCurrentCompanyId()">
        <form (ngSubmit)="onSubmit()" class="header-search">
          <i class="fa fa-search header-search__icon" aria-hidden="true"></i>
          <input type="text" name="search" [(ngModel)]="search" placeholder="Search HCPs, events, people…"
            class="header-search__input">
        </form>
      </li>
      <li class="nav-item dropdown topbar-cluster__item d-none d-md-flex">
        <a title="Notifications" aria-label="Notifications" data-bs-toggle="dropdown" class="position-relative" href="javascript:void(0)"
          aria-expanded="false" id="mailboxDropdown">
          <i class="mdi mdi-bell-outline"></i>
          <span *ngIf="unreadNotificationsCount != 0"
            class="position-absolute top-0 start-100 translate-middle p-1 mt-1 bg-danger border border-light rounded-circle"></span>
        </a>
        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="mailboxDropdown">
          <ng-container *ngTemplateOutlet="notifContent"></ng-container>
        </ul>
      </li>
      <li class="nav-item dropdown topbar-cluster__item d-none d-md-flex">
        <a title="Tasks" aria-label="Tasks" data-bs-toggle="dropdown" href="javascript:void(0)" aria-expanded="false" id="taskDropdown"
          class="position-relative">
          <i class="mdi mdi-format-list-checks"></i>
          <span *ngIf="userChecklist.length > 0"
            class="position-absolute top-0 start-100 translate-middle p-1 mt-1 bg-danger border border-light rounded-circle">
            <span class="visually-hidden">Tasks</span>
          </span>
        </a>
        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="taskDropdown">
          <ng-container *ngTemplateOutlet="tasksContent"></ng-container>
        </ul>
      </li>
      <li class="topbar-cluster__divider d-none d-md-block" aria-hidden="true"></li>
      <li class="nav-item topbar__acct">
        <header-account-menu [user]="user" [sandboxUrl]="sandboxUrl" (logoutClick)="logout()" (shadowToggle)="changeShadow()"></header-account-menu>
      </li>
    </ul>
    <header-primary-nav class="header-menuband" [fiscalYearId]="fiscalYearId"></header-primary-nav>
  </div>
</nav>

<!-- Shared notification / task content: rendered in the desktop dropdowns AND the mobile modal -->
<ng-template #notifContent>
  <li>
    <div *ngIf="unreadNotificationsCount == 0" class="dropdown-item">You have no new messages</div>
    <div *ngIf="unreadNotificationsCount != 0" class="dropdown-item">You have {{ unreadNotificationsCount }} new messages
    </div>
  </li>
  <li>
    <hr class="dropdown-divider">
  </li>
  <div *ngIf="unreadNotifications.length == 0" class="text-center">
    No unread messages.
  </div>
  <div *ngIf="unreadNotifications.length != 0">
    <li *ngFor="let not of unreadNotifications">
      <div class="message-center">
        <a href="javascript:void(0)" class="dropdown-item"
          title='{{ not.sender.first_name + " " + not.sender.last_name }}'>
          <div class="user-img">
            <img *ngIf="not.sender.photo" src="{{not.sender.photo}}" alt="user" class="img-circle">
            <img *ngIf="!not.sender.photo" src="assets/img/user-1.png" alt="user" class="img-circle">
            <span class="profile-status online float-end"></span>
          </div>
          <div class="mail-content">
            <h5>{{ not.sender.first_name + " " + not.sender.last_name }}</h5>
            <div class="mt-1">{{not.subject}}</div>
            <span class="mail-desc">{{not.content}}</span>
            <span class="time">{{ not.created_at | momentDate: 'MMMM D, YYYY hh:mm a z'}}</span>
          </div>
        </a>
      </div>
    </li>
  </div>
  <li>
    <hr class="dropdown-divider">
  </li>
  <li>
    <a class="dropdown-item text-center" routerLink="/my/notifications" (click)="mobileModal = null"
      title="See all notifications">
      <strong>See all notifications</strong>&nbsp;<i class="fa fa-angle-right"></i>
    </a>
  </li>
</ng-template>

<ng-template #tasksContent>
  <li>
    <div *ngIf="userChecklist.length == 0" class="dropdown-item">You have no tasks</div>
    <div *ngIf="userChecklist.length != 0 && authenticationService.is_staff_or_agency_staff()" class="dropdown-item">You
      have {{ userChecklist.length }} task(s)
    </div>
    <div *ngIf="userChecklist.length != 0 && authenticationService.is_client_corporate()" class="dropdown-item">
      You have {{ userChecklist.length }} Pending Request(s)
    </div>
  </li>
  <li>
    <hr class="dropdown-divider">
  </li>
  <li>
    <a *ngIf="authenticationService.is_staff_or_agency_staff()" class="dropdown-item text-center"
      routerLink="/my/checklists" (click)="mobileModal = null" title="See All Tasks">
      <strong>See All Tasks</strong>&nbsp;<i class="fa fa-angle-right"></i>
    </a>
    <a *ngIf="authenticationService.is_client_corporate()" class="dropdown-item text-center" routerLink="/my/checklists"
      (click)="mobileModal = null" title="See All Pending Requests">
      <strong>See All Pending Requests</strong>&nbsp;<i class="fa fa-angle-right"></i>
    </a>
  </li>
</ng-template>

<!-- Mobile: notifications / tasks open as a centered modal with a backdrop -->
<div class="bk-modal-overlay d-md-none" *ngIf="mobileModal" (click)="mobileModal = null">
  <div class="bk-modal" (click)="$event.stopPropagation()">
    <div class="bk-modal__header">
      <h5 class="bk-modal__title">{{ mobileModal === 'notifications' ? 'Notifications' : 'Tasks' }}</h5>
      <button type="button" class="bk-modal__close" (click)="mobileModal = null" aria-label="Close">
        <i class="fa fa-times"></i>
      </button>
    </div>
    <ul class="bk-modal__body list-unstyled">
      <ng-container *ngTemplateOutlet="mobileModal === 'notifications' ? notifContent : tasksContent"></ng-container>
    </ul>
  </div>
</div>
